var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/macros/personal-info-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["genderValue"], 
[], 
function (l_genderValue, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("genderValue", l_genderValue);
var t_2 = "";if(runtime.inOperator(l_genderValue,["FEMALE","F"])) {
t_2 += "\n        ";
t_2 += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-gal"])), env.opts.autoescape);
t_2 += "\n    ";
;
}
else {
if(runtime.inOperator(l_genderValue,["MALE","M"])) {
t_2 += "\n        ";
t_2 += runtime.suppressValue((lineno = 4, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-guy"])), env.opts.autoescape);
t_2 += "\n    ";
;
}
else {
t_2 += "\n        ";
t_2 += runtime.suppressValue((lineno = 6, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-ratherNotSay"])), env.opts.autoescape);
t_2 += "\n    ";
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("genderLocalizationSlug");
context.setVariable("genderLocalizationSlug", macro_t_1);
var macro_t_3 = runtime.makeMacro(
["profile"], 
[], 
function (l_profile, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("profile", l_profile);
var t_4 = "";var t_5;
t_5 = (lineno = 11, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_profile,"student.college",false]));
frame.set("isStudent", t_5, true);
if(frame.topLevel) {
context.setVariable("isStudent", t_5);
}
if(frame.topLevel) {
context.addExport("isStudent", t_5);
}
t_4 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isStudent")) {
t_4 += "\n        ";
t_4 += runtime.suppressValue((lineno = 13, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-yes"])), env.opts.autoescape);
t_4 += "\n    ";
;
}
else {
t_4 += "\n        ";
t_4 += runtime.suppressValue((lineno = 15, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-no"])), env.opts.autoescape);
t_4 += "\n    ";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_4);
});
context.addExport("areYouAStudent");
context.setVariable("areYouAStudent", macro_t_3);
var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";var t_8;
t_8 = (lineno = 20, colno = 43, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"getISODateOfBirth"), "Profile[\"getISODateOfBirth\"]", context, []));
frame.set("dobISO", t_8, true);
if(frame.topLevel) {
context.setVariable("dobISO", t_8);
}
if(frame.topLevel) {
context.addExport("dobISO", t_8);
}
t_7 += "\n\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "dobISO")) {
t_7 += "\n        ";
t_7 += runtime.suppressValue((lineno = 23, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-notSpecified"])), env.opts.autoescape);
t_7 += "\n    ";
;
}
else {
t_7 += "\n        ";
t_7 += runtime.suppressValue(env.getFilter("format_iso_datetime").call(context, runtime.contextOrFrameLookup(context, frame, "dobISO")), env.opts.autoescape);
t_7 += "\n    ";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
context.addExport("showDemographicsBirthDate");
context.setVariable("showDemographicsBirthDate", macro_t_6);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/macros/personal-info-macro.j2"] , dependencies)